import {
  TRANSACTION_SOURCES,
  type TransactionSource,
} from '@modules/reports/cma-reports/step-transaction/types';

export const encodeSelectionKey = (source: TransactionSource, id: string) =>
  `${source}:${id}`;

export const decodeSelectionKey = (key: string) => {
  const idx = key.indexOf(':');
  if (idx === -1) {
    return null;
  }
  const source = key.slice(0, idx);
  if (!TRANSACTION_SOURCES.includes(source as TransactionSource)) {
    return null;
  }
  return { source: source as TransactionSource, id: key.slice(idx + 1) };
};

export const partitionSelectionKeys = (keys: Iterable<string>) => {
  const crmTransactionIds: string[] = [];
  const externalTransactionRefs: Array<{
    source: Exclude<TransactionSource, 'crm'>;
    externalId: string;
  }> = [];
  for (const key of keys) {
    const decoded = decodeSelectionKey(key);
    if (decoded == null) {
      continue;
    }
    if (decoded.source === 'crm') {
      crmTransactionIds.push(decoded.id);
      continue;
    }
    externalTransactionRefs.push({
      source: decoded.source,
      externalId: decoded.id,
    });
  }
  return { crmTransactionIds, externalTransactionRefs };
};
